import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';

import OneVisualLayout from '../../layouts/one-visual';

import Image from '../../../../../containers/assets/instructor-successful-teams3.png'

class SuccessfulStep3 extends PureComponent {
  render() {
    return (
      <OneVisualLayout
        section="Successful Teams"
        title="Reason Why Teams Hit Their Targets"
        paragraph1={(
          <Fragment>
            <p>Teams that were successful in Round 3 did 3 things very well. They 1) reviewed their feedback, 2) analyzed their prior round financials, and then 3) made decisions that would allow them to make a profit and hit their return on investments targets.</p>
            <p>These teams likely made the connection in how each of the core functions impact various parts of the income statement and made decisions that helped them maximized their revenues while managing their expenses appropriately.</p>
          </Fragment>
        )}
        visual={(
          <img src={Image} alt='Income Statement' />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }
}

export default SuccessfulStep3;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/successful-teams/step3.js